export const baseUrl = '/';
export const apiPath = '/api/mall.';
export const staticUrl = '';
export const staticPath = '';

export default {
  baseUrl,
  apiPath,
  staticUrl,
  staticPath,
};



// WEBPACK FOOTER //
// ./src/units/config.js